export default __webpack_public_path__ + "static/media/Fleet Edge.9192c2bd.png";